import { CheckArgumentsTemplateListView } from "../check-arguments-templates-shared";
import { INTERNATIONAL_CRIMINAL_DATABASE_TEMPLATE_LIST_CONFIG } from "./config";

export const InternationalCriminalDatabaseTemplateListView =
  CheckArgumentsTemplateListView(
    INTERNATIONAL_CRIMINAL_DATABASE_TEMPLATE_LIST_CONFIG
  );
